<template>
  <div :style="{color}">
    <span v-if="value.absolute"
         :style="{color}"
         class="absolute"
         v-html="formattedNumber"
    />

    <span v-if="value.percentage"
          :class="['percentage', {'d-block': multiline}] "
    >
      ( {{value.percentage | percent | isNaN }} )
    </span>

    <span v-if="!value.absolute && !value.percentage">-</span>
  </div>
</template>

<script>
export default {
  name: "AbsoluteAndPercentageCell",
  props: {
    value: {},
    item: {},
    header: {},
  },
  computed: {
    formattedNumber() {
      let formattedNumber = this.$options.filters['numberFormattedShort'](this.value.absolute)
      if (formattedNumber !== '-') {
        formattedNumber = formattedNumber + '&nbsp;' + '€'
      }
      return formattedNumber
    },
    color() {
      let attr = null
      if (this.value.absolute) {
        attr = 'absolute'
      } else if (this.value.percentage) {
        attr = 'percentage'
      }

      if (this.value[attr] < 0) return this.$finColors.accentRed
      if (this.value[attr] > 0) return this.$finColors.accentGreen
      return this.$finColors.primaryDark
    },
    componentProps() {
      return this.header.componentProps
    },
    multiline() {
      return this.componentProps?.multiline || false
    }
  }
}
</script>

<style scoped>

</style>
